import { Box } from '@mantine/core';

interface Props {
	color: string;
	width?: number;
	height?: number;
}

export const StatusDotIcon = ({ color, width = 6, height = 6 }: Props) => (
	<Box
		data-testid="status-dot-icon"
		w={width}
		h={height}
		sx={{
			borderRadius: '50%',
			backgroundColor: color,
		}}
	/>
);
